import React, { useEffect, useRef, useState } from "react";
import CustomDropdown from "../../../../../components/Dropdown";
import { FaPlus } from "react-icons/fa";
import CreateTransactionModal from "./createTransaction";
import { Toast } from "primereact/toast";
import ReturnComponent from "./realEstateComponent/returnComponent";
import TradeComponent from "./realEstateComponent/tradeComponent";
import PictureComponent from "./realEstateComponent/pictureCompoenent";
import MovementComponent from "./realEstateComponent/movementComponent";
import {
  formatNumber,
  truncateText,
  truncateToTwoDecimals,
  getTabLabelsByAssetType,
  HorizontalTabButtons,
  getDropdownLabelsByAssetType,
  getBreadcrumbLabelsByAssetType,
} from "../../../../../utility/helper";
import {
  addMediaService,
  deleteMediaService,
  deleteTransaction,
  getFutureTransaction,
  getRoiRealEstateMediaService,
  getRoiRealEstateService,
  getRoiRealEstateStatsService,
  getTransaction,
} from "../../../../../services/transaction";
import { filterDropdownOptions } from "../../../../../utility/data";
import ConfirmDialog from "../../../../../components/ConfirmDialog";
import {
  clearSelectedAsset,
  fetchUserAssets,
  setSelectedAsset,
} from "../../../../../redux/slices/userAssetsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { handleErrorRedirect } from "../../../../../utility/errorRedirect";
import Breadcrumb from "../../../../../components/Breadcrumb";
import AssetGuardedActionButton from "../../../../../components/AddTransactionButton";
import RealEstateSkeleton from "../realEstate/realEstateComponent/realEstateSkelton";

const ViewTransaction = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mediaLoading, setMediaLoading] = useState(false);
  const [graphLoading, setGraphLoading] = useState(false);
  const [statsLoading, setStatsLoading] = useState(false);


  const dropdownOptions = getDropdownLabelsByAssetType("3");
  const breadcrumbItems = getBreadcrumbLabelsByAssetType("Real Estate");
  const { currency } = useSelector((state) => state.user);

  const [type, setType] = useState("");
  const [singleTransactionData, setSingleTransactionData] = useState({});
  const [limit, setLimit] = useState(20);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [filterType, setFilterType] = useState(filterDropdownOptions[0]);
  const [viewTransaction, setViewTransaction] = useState([]);
  const [viewFutureTransaction, setViewFutureTransaction] = useState([]);
  const [graphROI, setGraphROI] = useState([]);
  const [mediaData, setMediaData] = useState([]);
  const [statsData, setStatsData] = useState({});
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogConfig, setDialogConfig] = useState({});
  const [actionTypes, setActionTypes] = useState("Create");
  const [selectedButton, setSelectedButton] = useState("Return");
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const toast = useRef(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const id = location?.state?.id || null;
  const userAssets = useSelector((state) => state.userAssets.data);
  const { selectedAsset, userAssetLoading } = useSelector(
      (state) => state.userAssets
    );
  const sell = viewTransaction?.transactions?.find(
    (item) => item.type === "SELL"
  );

  const AcquisitionPrice =
    viewTransaction?.transactions?.find((item) => item?.is_initial === true)
      ?.amount ?? 0;

  const navigate = useNavigate();
  const tabOptions = getTabLabelsByAssetType("3");

  useEffect(() => {
    if (selectedAsset) {
      GetTransactionData();
      GetFutureTransactionData();
      GetRoiData();
      GetMediaData();
      GetstatsData();
    }
  }, [selectedAsset, filterType, page]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    dispatch(fetchUserAssets({ assetTypeId: 3, selectedAssetId: id })).then(
      (resultAction) => {
        if (fetchUserAssets.rejected.match(resultAction)) {
          const status = resultAction?.payload?.status;
          handleErrorRedirect(status, navigate);
        }
      }
    );
    return () => {
      dispatch(clearSelectedAsset());
    };
  }, [dispatch, id]);

  const openConfirmDialog = (config) => {
    setDialogConfig(config);
    setIsDialogOpen(true);
  };

  const handleOptionSelect = (option, actionTypes, data) => {
    setModalVisible(true);
    setType(option);
    setActionTypes(actionTypes);
    setSingleTransactionData(data);
  };

  const GetRoiData = async () => {
    setGraphLoading(true);
    try {
      const response = await getRoiRealEstateService(
        selectedAsset.id,
        accessToken
      );
      if (response.status === 200) {
        const data = response?.data.data;
        setGraphROI(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setGraphLoading(false);
    }
  };

  const GetMediaData = async () => {
    setMediaLoading(true);
    try {
      const response = await getRoiRealEstateMediaService(
        selectedAsset.id,
        accessToken
      );
      if (response.status === 200) {
        const data = response?.data.data;
        setMediaData(data ? data : []);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setMediaLoading(false);
    }
  };

  const GetstatsData = async () => {
    setStatsLoading(true);
    try {
      const response = await getRoiRealEstateStatsService(
        selectedAsset?.id,
        accessToken
      );
      if (response.status === 200) {
        const data = response?.data.data;
        setStatsData(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setStatsLoading(false);
    }
  };

  const GetTransactionData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getTransaction(
        selectedAsset?.id,
        3,
        page * limit,
        limit,
        filterType,
        accessToken
      );
      if (response.status === 200) {
        setViewTransaction(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      setError(err.message || "An error occurred");
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setLoading(false);
    }
  };

  const GetFutureTransactionData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getFutureTransaction(
        selectedAsset?.id,
        page,
        limit,
        filterType,
        3,
        accessToken
      );
      if (response.status === 200) {
        setViewFutureTransaction(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      setError(err.message || "An error occurred");
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setLoading(false);
    }
  };

  const handleTransactionDelete = async (deleteId) => {
    try {
      const response = await deleteTransaction(accessToken, deleteId.id);
      if (response) {
        dispatch(fetchUserAssets({ assetTypeId: 3, selectedAssetId: id }));
        GetTransactionData();
        GetFutureTransactionData();
        GetstatsData();
        GetRoiData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: "transaction deleted successfully",
          life: 3000,
        });
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    }
  };

  const handleMediaDelete = async (media_id) => {
    try {
      const response = await deleteMediaService(accessToken, media_id);
      if (response) {
        GetMediaData();
        dispatch(fetchUserAssets({ assetTypeId: 3, selectedAssetId: id }));
        GetTransactionData();
        GetFutureTransactionData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: "Image deleted successfully",
          life: 3000,
        });
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    }
  };

  const handleCreateMedia = async (media) => {
    try {
      const response = await addMediaService(
        media,
        selectedAsset?.id,
        "RealEstate",
        accessToken
      );
      if (response) {
        GetMediaData();
        dispatch(fetchUserAssets({ assetTypeId: 3, selectedAssetId: id }));
        GetTransactionData();
        GetFutureTransactionData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: "Image upload successfully",
          life: 3000,
        });
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    }
  };

  const confirmMediaDelete = (mediaId) => {
    openConfirmDialog({
      title: "Confirm Delete",
      message: "Are you sure you want to delete this media?",
      confirmText: "Delete",
      cancelText: "Cancel",
      cancelClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium border dark:border-gray-300 border-info rounded-md bg-transparent text-info dark:text-grey rounded-md focus:outline-none",
      confirmClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium dark:text-black dark:button-primary-gradient rounded-md bg-lightPrimary text-white rounded-md focus:outline-none",
      onConfirm: () => handleMediaDelete(mediaId),
    });
  };

  const confirmTransactionDelete = (transactionId) => {
    openConfirmDialog({
      title: "Confirm Delete",
      message: "Are you sure you want to delete this transaction?",
      confirmText: "Delete",
      cancelText: "Cancel",
      cancelClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium border dark:border-gray-300 border-info rounded-md bg-transparent text-info dark:text-grey rounded-md focus:outline-none",
      confirmClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium dark:text-black dark:button-primary-gradient rounded-md bg-lightPrimary text-white rounded-md focus:outline-none",
      onConfirm: () => handleTransactionDelete(transactionId),
    });
  };

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog
        isOpen={isDialogOpen}
        setIsOpen={setIsDialogOpen}
        {...dialogConfig}
      />
      <div>
        {/* <Breadcrumb items={breadcrumbItems} className="md:ml-5 mb-2" /> */}
        <div className="font-bold flex items-center justify-between px-4">
          <HorizontalTabButtons
            buttons={tabOptions}
            selected={selectedButton}
            onSelect={setSelectedButton}
          />
          {/* <div className="">
            <CustomDropdown
              options={dropdownOptions}
              name={""}
              assetId={""}
              icon={<FaPlus />}
              direction={"right"}
              truncateText={truncateText}
              size={19}
              className={`flex items-center border border-lightPrimary dark:border-none justify-center w-10 h-9 font-bold rounded-md 
              ${
                sell
                  ? "bg-gray-400 dark:bg-gray-600 text-white cursor-not-allowed border-none"
                  : "bg-expense text-white dark:text-black dark:button-primary-gradient"
              }
            `}
              onOptionSelect={(option) =>
                !sell && handleOptionSelect(option, "Create", {})
              }
              disabled={!!sell}
            />
          </div> */}

          <AssetGuardedActionButton
            userAssets={userAssets}
            onOptionSelect={handleOptionSelect}
            dropdownOptions={dropdownOptions}
            truncateText={truncateText}
            setIsDialogOpen={setIsDialogOpen}
            openConfirmDialog={openConfirmDialog}
            navigate={navigate}
            navigatePath="/my-view"
            assetsName={"Real Estate"}
            disabled={!!sell}
            sell={sell}
          />
        </div>
        <div className="p-3 mx-4 my-3 dark:bg-card-custom-radials bg-[length:100%_200%] bg-white border border-lightPrimary/40 dark:border-info/40">
          <div className="">
            <CustomDropdown
              options={userAssets}
              name={selectedAsset ? selectedAsset.name : "Select Asset"}
              assetId={selectedAsset ? selectedAsset.id : "Select Asset"}
              onOptionSelect={(option) => dispatch(setSelectedAsset(option))}
              returnFullObject={true}
              truncateText={truncateText}
              size={19}
              disabled={!selectedAsset || !selectedAsset.name}
              className="inline-flex whitespace-nowrap disabled:cursor-not-allowed disabled:dark:opacity-75 disabled:border-none justify-center px-1 py-1.5  items-center gap-1 text-[0.65rem] font-medium bg-transparent rounded-md text-lightPrimary dark:text-white border border-transparent hover:border-dark"
            />
          </div>
           {userAssetLoading || statsLoading ? (
            <RealEstateSkeleton />
          ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* <div className="ml-1 text-2xl text-lightPrimary dark:text-primary-gradient">
              {selectedAsset?.name}
            </div> */}
            <div className="space-y-3 text-info dark:text-grey text-sm w-full max-w-[30rem]">
              <div className="flex items-baseline gap-24">
                <span className="md:whitespace-nowrap">Value:</span>
                <span className="text-2xl text-lightPrimary dark:text-primary-gradient break-anywhere font-medium">
                  {formatNumber(
                    truncateToTwoDecimals(Number(statsData?.current_value ?? 0))
                  )}{" "}
                  {currency ? currency : ""}
                </span>
              </div>
              <div className="space-y-1">
                <div className="flex items-baseline gap-5">
                  <span className="md:whitespace-nowrap">Acquisition Price:</span>
                  <span className="text-2xl text-lightPrimary dark:text-primary-gradient break-anywhere font-medium">
                    {formatNumber(
                      truncateToTwoDecimals(Number(AcquisitionPrice ?? 0))
                    )}{" "}
                    {currency ? currency : ""}
                  </span>
                </div>
              </div>
            </div>

            <div className="space-y-3 text-sm text-info dark:text-grey w-full max-w-[30rem]">
              <div className="flex items-baseline gap-4">
                <span className="mr-1 md:whitespace-nowrap">
                  {Number(statsData?.total_gain ?? 0) >= 0 ? "Gain:" : "Loss:"}
                </span>
                <span
                  className={`text-2xl break-anywhere font-medium ${
                    Number(statsData?.total_gain ?? 0) >= 0
                      ? "text-lightPrimary dark:text-primary-gradient"
                      : "text-expense dark:text-warning"
                  }`}
                >
                  {formatNumber(
                    truncateToTwoDecimals(
                      Math.abs(Number(statsData?.total_gain ?? 0))
                    )
                  )}{" "}
                  {currency ? currency : ""}
                </span>
              </div>
              <div className="flex items-baseline gap-5">
                <span className="mr-1 md:whitespace-nowrap">ROI:</span>
                <span
                  className={`text-2xl break-anywhere font-medium ${
                    Number(statsData?.roi ?? 0) >= 0
                      ? "text-lightPrimary dark:text-primary-gradient"
                      : "text-expense dark:text-warning"
                  }`}
                >
                  {formatNumber(
                    truncateToTwoDecimals(Math.abs(Number(statsData?.roi ?? 0)))
                  )}
                  %
                </span>
              </div>
            </div>

            <div className="grid grid-col-2 text-sm text-info dark:text-grey w-full max-w-[30rem]">
              <div className="space-y-3">
                <div className="flex items-baseline gap-8">
                  <span className="md:whitespace-nowrap">
                    {Number(statsData?.realized_profit ?? 0) >= 0
                      ? "Realised Profit:"
                      : "Realised Loss:"}
                  </span>

                  <span
                    className={`text-2xl break-anywhere font-medium ${
                      Number(statsData?.realized_profit ?? 0) >= 0
                        ? "text-lightPrimary dark:text-primary-gradient"
                        : "text-expense dark:text-warning"
                    }`}
                  >
                    {formatNumber(
                      truncateToTwoDecimals(
                        Math.abs(Number(statsData?.realized_profit ?? 0))
                      )
                    )}{" "}
                    {currency || ""}
                  </span>
                </div>

                <div className="flex items-baseline gap-6">
                  <span className="md:whitespace-nowrap">
                    {Number(statsData?.unrealized_profit ?? 0) >= 0
                      ? "Unrealised Profit:"
                      : "Unrealised Loss:"}
                  </span>

                  <span
                    className={`text-2xl break-anywhere font-medium ${
                      Number(statsData?.unrealized_profit ?? 0) >= 0
                        ? "text-lightPrimary dark:text-primary-gradient"
                        : "text-expense dark:text-warning"
                    }`}
                  >
                    {formatNumber(
                      truncateToTwoDecimals(
                        Math.abs(Number(statsData?.unrealized_profit ?? 0))
                      )
                    )}{" "}
                    {currency || ""}
                  </span>
                </div>
              </div>
            </div>
            <div className="grid grid-col-2 text-sm text-info dark:text-grey w-full max-w-[30rem]">
              <div className="space-y-3">
                <div className="flex items-baseline gap-6">
                  <span className="md:whitespace-nowrap">Income:</span>
                  <span className="text-lightPrimary text-2xl break-anywhere dark:text-primary-gradient font-medium">
                    {formatNumber(
                      truncateToTwoDecimals(Number(statsData?.income ?? 0))
                    )}{" "}
                    {currency ? currency : ""}
                  </span>
                </div>
                <div className="flex items-baseline gap-5">
                  <span className="md:whitespace-nowrap">Expense:</span>
                  <span className="text-expense break-anywhere text-2xl dark:text-warning font-medium">
                    {formatNumber(
                      truncateToTwoDecimals(Number(statsData?.expense ?? 0))
                    )}{" "}
                    {currency ? currency : ""}
                  </span>
                </div>
              </div>
            </div>
          </div>)}
        </div>
        <div className="mt-5 mx-4">
          {selectedButton === "Return" && (
            <ReturnComponent
              graphROI={graphROI}
              selectedAsset={selectedAsset}
              mediaData={mediaData}
              mediaLoading={mediaLoading}
              graphLoading={graphLoading}
            />
          )}
          {selectedButton === "Cashflow" && <TradeComponent />}
          {selectedButton === "Pictures" && (
            <PictureComponent
              handleMediaDelete={confirmMediaDelete}
              mediaData={mediaData}
              handleCreateMedia={handleCreateMedia}
              mediaLoading={mediaLoading}
            />
          )}
          {selectedButton === "Movements" && (
            <MovementComponent
              confirmDelete={confirmTransactionDelete}
              handleOptionSelect={handleOptionSelect}
              viewTransaction={viewTransaction}
              viewFutureTransaction={viewFutureTransaction}
              setLimit={setLimit}
              limit={limit}
              setPage={setPage}
              page={page}
              selectedAsset={selectedAsset}
            />
          )}
        </div>
        <CreateTransactionModal
          visible={modalVisible}
          singleTransactionData={singleTransactionData}
          actionTypes={actionTypes}
          fetchTransactionData={GetTransactionData}
          fetchFutureTransactionData={GetFutureTransactionData}
          GetstatsData={GetstatsData}
          GetRoiData={GetRoiData}
          statsData={statsData}
          viewTransaction={viewTransaction}
          onHide={() => {
            setModalVisible(false);
          }}
          SelectType={type}
          toast={toast}
          loading={loading}
          setLoading={setLoading}
          assetName={selectedAsset}
        />
      </div>
    </>
  );
};

export default ViewTransaction;
